import { useIVAContext } from '../context/IVAContext';

// Hook wrapper para mantener compatibilidad, pero usando el contexto global
export const useIVA = () => {
    const { retenciones, loading, error, fetchRetenciones, createRetencion } = useIVAContext();

    // Opcional: Cargar automáticamente si se desea mantener el comportamiento anterior,
    // o dejar que el componente lo decida.
    // Para simplificar la migración, podemos exponer todo tal cual.

    return {
        retenciones,
        loading,
        error,
        fetchRetenciones,
        createRetencion
    };
};
